import React, { useState, useEffect } from 'react'
import BackLogo from '../../../../../../images/rewampimages/Chevron.png';
import EditLogo from '../../../../../../images/rewampimages/edit.png'
import UserLogo from '../../../../../../images/rewampimages/user.png'
import IdentityLogo from '../../../../../../images/rewampimages/ID Card.png'
import ResidentialLogo from '../../../../../../images/rewampimages/residential.png'
import BankLogo from '../../../../../../images/rewampimages/bank.png'
import VerifyImage from '../../../../../../images/rewampimages/verifytick.png'
import NotVerified from '../../../../../../images/rewampimages/unverified.png'
import DocLogo from '../../../../../../images/rewampimages/document.png'
export default function EditUserDetailsNewContainer({ allData, handleAadhaarPanPopup, panData, aadhaarData, documentData, selectedDocument, handleDocumentSelected, handleEditdata, viewType, referenceData }) {
    const thStyle = { padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '2px solid #e5e7eb', whiteSpace: 'nowrap' };
    const tdStyle = { padding: '9px 12px', borderBottom: '1px solid #f3f4f6', color: '#1f2937', verticalAlign: 'middle' };
    return (
        <>

            <div className='container-fluid details-new  animated fadeIn' style={{ background: window.innerWidth < 1800 ? '#F2F2FA' : '#fff', paddingBottom: '30px', paddingTop: '40px' }}>
                <div className='row height-81'>
                    <div className="col-sm-8 col-xs-12">
                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-11 col-xs-11">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Personal Information</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "personal", allData)} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Salutation</label>
                                        <p>{allData?.salutation || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>First Name</label>
                                        <p>{allData?.firstName || ""}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Middle Name</label>
                                        <p>{allData?.middleName || ""}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Last Name</label>
                                        <p>{allData?.lastName || ""}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Email Id</label>
                                        <p>{allData?.emailId || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Gender</label>
                                        <p>{allData?.gender || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>D.O.B</label>
                                        <p>{allData?.dateOfBirth || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Mobile Number</label>
                                        <p>{allData?.mobileNumber || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Prefered Language</label>
                                        <p>{allData?.preferredLanguage || "N/A"}</p>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-11 col-xs-11">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={IdentityLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Basic Information</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "basic", allData)} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Care Of</label>
                                        <p>{allData?.careOf || "N/A"}</p>
                                    </div>

                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Relation with Care Of</label>
                                        <p>{allData?.relationWithCareOf || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Caste</label>
                                        <p>{allData?.caste || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Marital Status</label>
                                        <p>{allData?.maritalStatus || "N/A"}</p>
                                    </div>

                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Education Qualification</label>
                                        <p>{allData?.highestQualification || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Total Family Members</label>
                                        <p>{allData?.totalFamilyMember || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Number of Earning Members</label>
                                        <p>{allData?.noOfEarningMembers || "N/A"}</p>
                                    </div>


                                </div>

                            </div>
                        </div>


                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-11 col-xs-11">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={ResidentialLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Current Address</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "currentAddress", allData)} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Address Type</label>
                                        <p>{allData?.addressDetailsPO?.currentResidenceType || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Rented Amount (if Rented)</label>
                                        <p>{allData?.addressDetailsPO?.currentMonthlyRent || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Duration</label>
                                        <p>{allData?.addressDetailsPO?.currentStayDuration || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Pincode</label>
                                        <p>{allData?.addressDetailsPO?.currentPincode || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Address Line</label>
                                        <p>{allData?.addressDetailsPO?.currentAddress || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Town</label>
                                        <p>{allData?.addressDetailsPO?.currentTown || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>City/Village</label>
                                        <p>{allData?.addressDetailsPO?.currentCity || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Landmark</label>
                                        <p>{allData?.addressDetailsPO?.currentLandmark || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>District</label>
                                        <p>{allData?.addressDetailsPO?.currentDistrict || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>State</label>
                                        <p>{allData?.addressDetailsPO?.currentState || "N/A"}</p>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-11 col-xs-11">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={ResidentialLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Permanent Address</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "permanentAddress", allData)} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Address Type</label>
                                        <p>{allData?.addressDetailsPO?.permanentResidenceType || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Rented Amount (if Rented)</label>
                                        <p>{allData?.addressDetailsPO?.permanentMonthlyRent || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Duration</label>
                                        <p>{allData?.addressDetailsPO?.permanentResidenceValue || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Pincode</label>
                                        <p>{allData?.addressDetailsPO?.permanentPincode || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Address Line</label>
                                        <p>{allData?.addressDetailsPO?.permanentAddress || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Town</label>
                                        <p>{allData?.addressDetailsPO?.permanentTown || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>City/Village</label>
                                        <p>{allData?.addressDetailsPO?.permanentCity || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>Landmark</label>
                                        <p>{allData?.addressDetailsPO?.permanentLandmark || "N/A"}</p>
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>District</label>
                                        <p>{allData?.addressDetailsPO?.permanentDistrict || "N/A"}</p>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '10px' }}>
                                        <label>State</label>
                                        <p>{allData?.addressDetailsPO?.permanentState || "N/A"}</p>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="col-sm-4 col-xs-12">
                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-10 col-xs-10">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={IdentityLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Identity Information & Verification</b>
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-2 col-xs-2" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={()=>handleEditdata(true,"identityInfo",allData)} />
                                    </div> */}
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="bank-box">
                                    <div style={{ borderRadius: '12px 12px 0 0', background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Pan Number</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.panNumber || "N/A"}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Name as on PAN</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.nameAsOnPan || "N/A"}</span>
                                    </div>
                                    <div style={{ background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Aadhar Number</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.aadhaarNumber || "-"}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Pan Verified</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.panVerified == true ? <img src={VerifyImage} width="22px" /> : <img src={NotVerified} width="22px" /> || "N/A"} &nbsp; {panData !== '' && panData !== null && panData !== undefined ? <button className='i-button' onClick={() => handleAadhaarPanPopup(true, "pan")}><i className="fa fa-info" /></button> : ""}</span>
                                    </div>
                                    <div style={{ borderRadius: '0 0 12px 12px', background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Aadhar Verified</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{aadhaarData?.status == true ? <img src={VerifyImage} width="22px" /> : <img src={NotVerified} width="22px" /> || "N/A"} &nbsp; {aadhaarData?.status == true ? <button className='i-button' onClick={(e) => handleAadhaarPanPopup(true, "aadhaar")}><i className="fa fa-info" /></button> : ""}</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-10 col-xs-10">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={IdentityLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Employment Information</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-2 col-xs-2" style={{ textAlign: 'end' }}>
                                        <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "employment", allData)} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="bank-box">
                                    <div style={{ borderRadius: '12px 12px 0 0', background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Employment Type</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.employerType || "N/A"}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Monthly Income</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.monthlyIncome || ""}</span>
                                    </div>
                                    <div style={{ background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Annual Income</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.annualIncome || ""}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Current Business (if any)</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.otherIncome == true ? "Yes" : "No" || ""}</span>
                                    </div>
                                    <div style={{ background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Nature of Income</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.natureOfIncome || "N/A"}</span>
                                    </div>

                                    <div style={{ borderRadius: '0 0 12px 12px', background: '#fff', padding: '19.2px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Employment Start Date</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.businessStartDate || ""}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {
                            viewType === "borrower" ?

                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                                    <div className="details-head">
                                        <div className="row">
                                            <div className="col-sm-10 col-xs-10">
                                                <div style={{ marginTop: '6px' }}>
                                                    <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                    <b style={{ marginTop: '14px' }}>Account Information</b>
                                                </div>
                                            </div>
                                            <div className="col-sm-2 col-xs-2" style={{ textAlign: 'end' }}>
                                                <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "account", allData)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                        <div className="bank-box">
                                            <div style={{ borderRadius: '12px 12px 0 0', background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Name As On Bank </span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.nameAsBankAccount || ""}</span>
                                            </div>
                                            <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Bank Name</span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.bankName || ""}</span>
                                            </div>
                                            <div style={{ background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Account Number</span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.accountNumber || ""}</span>
                                            </div>
                                            <div style={{ background: '#fff', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>IFSC Code</span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.ifscCode || ""}</span>
                                            </div>
                                            <div style={{ background: 'rgb(241, 247, 255)', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Branch Name</span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.branch || ""}</span>
                                            </div>
                                            <div style={{ borderRadius: '0 0 12px 12px', background: '#fff', padding: '19.2px 15px' }}>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Account Type</span>
                                                <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{allData?.ifSalariedAccount || ""}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                : ''}

                        {/* <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                            <div className="details-head">
                                <div className="row">
                                    <div className="col-sm-9 col-xs-9">
                                        <div style={{ marginTop: '6px' }}>
                                            <img src={BankLogo} style={{ width: '20px' }} /> &nbsp;
                                            <b style={{ marginTop: '14px' }}>Bank Verification Details</b>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 col-xs-3" style={{ textAlign: 'end' }}>
                                        <button className='btn btn-primary' style={{ padding: '10px', marginBottom: '0px', color: '#fff' }}>Verify</button>
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                <div className="bank-box">
                                    <div style={{ borderRadius: '12px 12px 0 0', background: 'rgb(241, 247, 255)', padding: '19px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Name As On Bank </span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{`nameAsonBank` || ""}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Account Number</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{`accountNumber` || ""}</span>
                                    </div>
                                    <div style={{ background: 'rgb(241, 247, 255)', padding: '19px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>IFSC Code</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{`ifsccode` || ""}</span>
                                    </div>
                                    <div style={{ background: '#fff', padding: '19px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Is Valid</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{`isValid` || ""}</span>
                                    </div>
                                    <div style={{ borderRadius: '0 0 12px 12px', background: 'rgb(241, 247, 255)', padding: '19px 15px' }}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.7)' }}>Bank Response</span>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.8)', fontWeight: '700 ', float: 'right' }}>{`bankResponse` || ""}</span>
                                    </div>
                                </div>

                            </div>
                        </div> */}
                    </div>
                    {
                        viewType === "borrower" ?
<>
                            <div className="col-xs-12">
                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                                    <div className="details-head">
                                        <div className="row">
                                            <div className="col-sm-11 col-xs-11">
                                                <div style={{ marginTop: '6px' }}>
                                                    <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                    <b style={{ marginTop: '14px' }}>Vehicle information</b>
                                                </div>
                                            </div>
                                            <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                                <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "vehicle", allData)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                        <div className="row" >
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Vehicle Type</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.vehicleType || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Vehicle Make</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.make || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Vehicle Make Class</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.makeClass || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Vehicle Variant</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.variant || "N/A"}</p>
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Manufacture Year</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.manufactureYear || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Registration Date</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.registrationDate || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Battery Type</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.batteryType || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Battery Warranty</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.batteryWarranty || "N/A"}</p>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Motor Power</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.motorPower || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Battery Voltage</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.batteryVoltage || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Capacity</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.capacity || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Vehicle weight</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.vehicleWeight || "N/A"}</p>
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Invoice Amount</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.invoiceAmount || "N/A"}</p>
                                            </div>
                                            <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                <label>Battery OEM</label>
                                                <p>{allData?.assetAndVehicleDetailPO?.batteryOemId || "N/A"}</p>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                                    <div className="details-head">
                                        <div className="row">
                                            <div className="col-sm-11 col-xs-11">
                                                <div style={{ marginTop: '6px' }}>
                                                    <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                    <b style={{ marginTop: '14px' }}>Reference information</b>
                                                </div>
                                            </div>
                                            <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                                {/* <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "vehicle", allData)} /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                        <div className="row" >
                                            <div className="col-xs-12" style={{ marginTop: '10px' }}>
                                                {referenceData && referenceData.length > 0 ? (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                                        <thead>
                                                            <tr style={{ background: '#f1f7ff' }}>
                                                                <th style={thStyle}>#</th>
                                                                <th style={thStyle}>Name</th>
                                                                <th style={thStyle}>Number</th>
                                                                <th style={thStyle}>Relationship</th>
                                                                <th style={thStyle}>Verified</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {referenceData.slice(0, 3).map((ref, idx) => (
                                                                <tr key={idx} style={{ background: idx % 2 === 0 ? '#fff' : '#f8faff' }}>
                                                                    <td style={tdStyle}>{idx + 1}</td>
                                                                    <td style={tdStyle}>{ref.name || <span style={{ color: '#aaa' }}>—</span>}</td>
                                                                    <td style={tdStyle}>{ref.number && ref.number !== 0 ? ref.number : <span style={{ color: '#aaa' }}>—</span>}</td>
                                                                    <td style={tdStyle}>{ref.relationShip || <span style={{ color: '#aaa' }}>—</span>}</td>
                                                                    <td style={tdStyle}>
                                                                        <span style={{
                                                                            display: 'inline-block',
                                                                            padding: '2px 10px',
                                                                            borderRadius: '20px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '600',
                                                                            background: ref.verified ? '#d1fae5' : '#fee2e2',
                                                                            color: ref.verified ? '#065f46' : '#991b1b'
                                                                        }}>
                                                                            {ref.verified ? 'Verified' : 'Not Verified'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <p style={{ color: '#aaa', fontSize: '13px' }}>No reference data available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
</>
                            : ''}

                    {
                        documentData && documentData?.length > 0 ?
                            <div className="col-xs-12">
                                <div className="details-body" style={{ marginTop: '30px', boxShadow: '3px 3px 10px -8px grey', minHeight: '130px' }}>
                                    <div className="details-head">
                                        <div className="row">
                                            <div className="col-sm-10 col-xs-10">
                                                <div style={{ marginTop: '6px' }}>
                                                    <img src={DocLogo} style={{ width: '20px' }} /> &nbsp;
                                                    <b style={{ marginTop: '14px' }}>Documents</b>
                                                </div>
                                            </div>
                                            <div className="col-sm-2 col-xs-2" style={{ textAlign: 'end' }}>
                                                <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => handleEditdata(true, "document", allData)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ padding: '17px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                        <select className='form-control' style={{ width: '15%' }} value={selectedDocument?.documentUrl} onChange={(e) => handleDocumentSelected(e)}>
                                            <option value={""}>Select Document</option>
                                            {

                                                documentData?.map((value, index) => {
                                                    if (value?.documentType !== "PRE") {
                                                        return
                                                    }
                                                    return (
                                                        <option value={value?.documentUrl}>{value?.documentName}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        {
                                            Object.keys(selectedDocument)?.length > 0 ?

                                                <div style={{ marginTop: '20px' }}>
                                                    <div className='document-box'>
                                                        <div style={{ marginBottom: '10px' }}><a target='_blank' href={selectedDocument?.documentUrl}>{selectedDocument?.documentName}</a></div>
                                                        <iframe className="obj-doc" src={selectedDocument?.documentUrl}></iframe>
                                                    </div>
                                                </div>
                                                : ''}
                                    </div>
                                </div>
                            </div>
                            : ''}
                </div>
            </div>
        </>
    )
}
